import { useState } from 'react';

import type { KeyboardEvent } from 'react';

type EditableLabelProps = {
  label: string;
  onUpdate: (newLabel: string) => void;
};

export function EditableLabel({ label, onUpdate }: EditableLabelProps) {
  const [isEditing, setIsEditing] = useState(false);
  const [editingValue, setEditingValue] = useState('');

  const startEditing = () => {
    setIsEditing(true);
    setEditingValue(label);
  };

  const handleUpdate = () => {
    if (editingValue.trim() && editingValue !== label) {
      onUpdate(editingValue);
    }
    setIsEditing(false);
  };

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      handleUpdate();
    } else if (e.key === 'Escape') {
      setIsEditing(false);
    }
  };

  if (isEditing) {
    return (
      <input
        type="text"
        value={editingValue}
        onChange={e => setEditingValue(e.target.value)}
        onBlur={handleUpdate}
        onKeyDown={handleKeyDown}
        autoFocus
        style={{
          width: '180px',
          fontSize: 14,
          fontWeight: 500,
          color: 'var(--light-body-color)',
          border: 'none',
          borderRadius: 4,
          padding: '4px 8px',
          outline: 'none',
          backgroundColor: 'var(--light-bg-color)',
        }}
      />
    );
  }

  return (
    <span
      onClick={startEditing}
      style={{
        fontSize: 14,
        fontWeight: 500,
        width: '180px',
        color: 'var(--light-body-color)',
        cursor: 'pointer',
        padding: '4px 8px',
        borderRadius: 4,
        transition: 'background-color 0.2s',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
      }}
      onMouseEnter={e => {
        e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.05)';
      }}
      onMouseLeave={e => {
        e.currentTarget.style.backgroundColor = 'transparent';
      }}
    >
      {label}
    </span>
  );
}
